import React from "react";
import styles from "../styles/pages/projects.module.css"

function Projects() {
    return (<div className={styles.about}>
projects
    </div>);
}

export default Projects;